import { Typography } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import { alpha, styled } from '@mui/material/styles';
import search from 'assets/images/search.svg';
import React, { ReactElement } from 'react';

const Search = styled('div')(({ theme }) => ({
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  borderRadius: theme.shape.borderRadius,
  marginLeft: 0,
  marginRight: theme.spacing(2),
  position: 'relative',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(0),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(0, 2),
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: '1',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  color: 'inherit',
}));

type InputProps = {
  onChange?: (src: any) => void;
  value?: string;
};

const Searchbar = React.forwardRef((props: InputProps): ReactElement => {
  const { onChange, value } = props;
  return (
    <Typography className="custom-search">
      <Search>
        <SearchIconWrapper>
          <img className="sidebar-inner" src={search} />
        </SearchIconWrapper>
        <StyledInputBase
          onChange={onChange && onChange}
          placeholder="Search…"
          value={value}
          inputProps={{ 'aria-label': 'search' }}
        />
      </Search>
    </Typography>
  );
});

export default Searchbar;
